import React from 'react';
import styles from '../../../styles/DocumentManagement.module.css';

interface SkeletonLineProps { width?: string; height?: number }
const SkeletonLine: React.FC<SkeletonLineProps> = ({ width = '100%', height = 16 }) => (
  <div className={styles.skeletonLine} style={{ width, height }} />
);

interface SkeletonCircleProps { size?: number }
const SkeletonCircle: React.FC<SkeletonCircleProps> = ({ size = 44 }) => (
  <div className={styles.skeletonCircle} style={{ width: size, height: size }} />
);

const SkeletonCategoryCard: React.FC = () => (
  <div className={styles.skeletonCard}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <SkeletonLine width="55%" height={20} />
      <SkeletonLine width="12%" height={20} />
    </div>
    <SkeletonLine height={8} />
  </div>
);

const SkeletonAgentCard: React.FC = () => (
  <div className={styles.skeletonCard}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <SkeletonCircle size={44} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <SkeletonLine width="58%" height={15} />
        <SkeletonLine width="78%" height={12} />
      </div>
    </div>
    <SkeletonLine height={7} />
    <div style={{ display: 'flex', gap: 8 }}>
      <SkeletonLine width="28%" height={20} />
      <SkeletonLine width="28%" height={20} />
    </div>
  </div>
);

const SkeletonHeroCard: React.FC = () => (
  <div className={styles.skeletonCard} style={{ gap: 8 }}>
    <SkeletonLine width="28%" height={18} />
    <SkeletonLine width="45%" height={34} />
    <SkeletonLine width="62%" height={11} />
  </div>
);

interface SkeletonLoaderProps {
  variant?: 'categoryList' | 'agentGrid' | 'overviewHero' | 'lines';
  count?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ variant = 'lines', count = 3 }) => {
  if (variant === 'categoryList') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {Array.from({ length: count }).map((_, i) => <SkeletonCategoryCard key={i} />)}
      </div>
    );
  }

  if (variant === 'agentGrid') {
    return (
      <div className={styles.skeletonGridTwoCol} style={{ marginTop: 18 }}>
        {Array.from({ length: count }).map((_, i) => <SkeletonAgentCard key={i} />)}
      </div>
    );
  }

  if (variant === 'overviewHero') {
    return (
      <div className={styles.skeletonHeroGrid}>
        {Array.from({ length: count }).map((_, i) => <SkeletonHeroCard key={i} />)}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {Array.from({ length: count }).map((_, i) => <SkeletonLine key={i} height={16} />)}
    </div>
  );
};

export default SkeletonLoader;
